import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DateTime } from 'luxon';
import { forwardRef } from 'react';

interface VoteDatePillProps {
  voteDate: string;
  selected: boolean;
  handleClick?: (voteDate: string) => void;
}

export const VoteDatePill = forwardRef<HTMLButtonElement, VoteDatePillProps>(
  ({ voteDate, selected, handleClick }, ref) => (
    <StyledVoteDatePill ref={ref} selected={selected} onClick={() => handleClick?.(voteDate)}>
      {DateTime.fromFormat(voteDate, 'yyyy-MM-dd', { zone: 'Asia/Seoul' }).toFormat('M월 d일')}
    </StyledVoteDatePill>
  ),
);

VoteDatePill.displayName = 'VoteDatePill';

const StyledVoteDatePill = styled.button(
  ({ selected }: { selected: boolean }) => css`
    box-sizing: border-box;
    min-width: 65px;
    min-height: 40px;
    margin-bottom: 1px;
    border-radius: 100px;

    ${Typography.XXXSmall};
    cursor: pointer;

    border: 1px solid ${selected ? Color.Black : Color.Gray200};

    background-color: ${selected ? Color.Black : Color.White};
    color: ${selected ? Color.White : Color.Black};
    font-weight: ${selected ? FontWeight.Bold : FontWeight.Medium};
  `,
);
